module.exports = __webpack_public_path__ + "img/fenge_icon.812f574a.png";